import { Button, Col, Form, notification, Popconfirm, Row } from 'antd';
import { useAppSelector } from 'app/hooks';
import clsx from 'clsx';
import { selectInverterItemSidebar } from 'components/Common/Sidebar/sidebarSlice';
import * as React from 'react';
import ProtectionLevelOne from '../ProtectionLevelOne/ProtectionLevelOne';
import ProtectionLevelThree from '../ProtectionLevelThree/ProtectionLevelThree';
import ProtectionLevelTwo from '../ProtectionLevelTwo/ProtectionLevelTwo';
import style from './Protection.module.scss';
export interface ProtectionProps {
  inverterConfig: any;
}

export default function Protection(props: ProtectionProps) {
  const { inverterConfig } = props;
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [inputList, setInputList] = React.useState([]);
  const inverterId = useAppSelector(selectInverterItemSidebar);
  const [isShowComponent, setIsShowComponent] = React.useState('level_one');

  // React.useEffect(() => {
  //   if (inverterConfig) {
  //     setInputList(inverterConfig.config.param_list);
  //   }
  // }, [inverterConfig]);
  const [levelOne, setLevelOne] = React.useState({
    o_p_th: 231.65,
    o_p_t: 0.01,
    l_p_th: 185.2,
    l_p_t: 5.3,
    o_f_p_th: 52.7,
    o_f_p_t: 45.23,
    l_f_p_th: 48,
    l_f_p_t: 405.1,
  });
  const [levelTwo, setLevelTwo] = React.useState({
    o_p_th: 272.65,
    o_p_t: 4.01,
    l_p_th: 285.2,
    l_p_t: 15.3,
    o_f_p_th: 50.7,
    o_f_p_t: 453.23,
    l_f_p_th: 47,
    l_f_p_t: 401.11,
  });
  const [levelThree, setLevelThree] = React.useState({
    o_p_th: 281.5,
    o_p_t: 10.01,
    l_p_th: 193.2,
    l_p_t: 25.13,
    o_f_p_th: 51.7,
    o_f_p_t: 209.23,
    l_f_p_th: 46,
    l_f_p_t: 423.1,
  });

  const openNotificationWithIcon = (type: string, message: string) => {
    if (type === 'success' || type === 'error') notification[type]({ message: message });
    return;
  };

  const handleSubmit = (val: any) => {
    console.log('🚀 ~ file: Protection.tsx ~ line 47 ~ handleSubmit ~ val', val);
    // setMonthly({ ...monthly, ...val });
    setIsModalVisible(false);
  };

  return (
    <Row align="top" className={style.root}>
      <Row className={style.header_info}>
        <Col span={19} className={style.header_label_info}>
          Protection parameters
        </Col>
        <Col span={5} className={style.header_group_btn}>
          {isModalVisible && (
            <Button
              onClick={() => {
                form.resetFields();
                setIsModalVisible(false);
              }}
              className={style.btn_delete}
            >
              Reset
            </Button>
          )}
          <Popconfirm
            disabled={!isModalVisible ? true : false}
            placement="bottomLeft"
            title="Sure to save?"
            onConfirm={() => form.submit()}
          >
            <Button className={style.btn_edit}>
              Save
              {/* <FiEdit style={{ marginLeft: '10px' }} /> */}
            </Button>
          </Popconfirm>
        </Col>
      </Row>
      <Row align="top" className={style.main_detail}>
        <Row className={style.title_group_btn}>
          <Col
            span={8}
            onClick={() => {
              setIsShowComponent('level_one');
              setIsModalVisible(false);
            }}
            className={clsx(style.btn_title, {
              [style.active_one]: isShowComponent === 'level_one',
            })}
          >
            Level 1
          </Col>
          <Col
            span={8}
            onClick={() => {
              setIsShowComponent('level_two');
              setIsModalVisible(false);
            }}
            className={clsx(style.btn_title, {
              [style.active_two]: isShowComponent === 'level_two',
            })}
          >
            Level 2
          </Col>
          <Col
            span={8}
            onClick={() => {
              setIsShowComponent('level_three');
              setIsModalVisible(false);
            }}
            className={clsx(style.btn_title, {
              [style.active_three]: isShowComponent === 'level_three',
            })}
          >
            Level 3
          </Col>
        </Row>
        {isShowComponent === 'level_one' ? (
          <ProtectionLevelOne
          form={form}
          handleSubmit={handleSubmit}
          setIsModalVisible={setIsModalVisible}
          levelOne={levelOne}
          />
        ) : isShowComponent === 'level_two' ? (
          <ProtectionLevelTwo
          form={form}
          handleSubmit={handleSubmit}
          setIsModalVisible={setIsModalVisible}
          levelTwo={levelTwo}
          />
        ) : (
          <ProtectionLevelThree
            form={form}
            handleSubmit={handleSubmit}
            setIsModalVisible={setIsModalVisible}
            levelThree={levelThree}
          />
        )}
        {/* <Form
          layout="vertical"
          form={form}
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 8,
          }}
          style={{ width: '100%' }}
          hideRequiredMark
          onFinish={(values) => handleOk(values)}
          onValuesChange={() => setIsModalVisible(true)}
        >
          {getFields(inputList)}
        </Form> */}
      </Row>
    </Row>
  );
}
